import {capitalize, snakeToWords} from "@/state/helpers";
import axios from "axios";

export default class CartPreviewPdf {

    constructor(influencerCartItems, cartRowsByInfluencers) {
        this.influencerCartItems = influencerCartItems;
        this.cartRowsByInfluencer = cartRowsByInfluencers;
    }

    generate() {
        const columns = ['Username', 'Social network', 'Followers/Subscribers', 'Post type', 'Price per post', 'Amount', 'Total'];
        const rows = [];

        for (let influencerCartItem of this.influencerCartItems) {
            const cartRowsForInfluencer = this.cartRowsByInfluencer[influencerCartItem.influencerId];
            for (let row of cartRowsForInfluencer) {
                const username = influencerCartItem.username;
                const socialNetwork = capitalize(row.socialNetwork);
                let followers = 0;
                if (row.socialNetwork === 'youtube') {
                    followers = influencerCartItem.socialNetworkAccounts[row.socialNetwork].subscribers;
                } else if (row.socialNetwork === 'facebook') {
                    followers = influencerCartItem.socialNetworkAccounts[row.socialNetwork].fan_count;
                } else if (row.socialNetwork === 'instagram') {
                    followers = influencerCartItem.socialNetworkAccounts[row.socialNetwork].followers_count;
                }
                const postType = capitalize(snakeToWords(row.postType))
                const pricePerPost = row.price ? row.price.toLocaleString() : '-';
                const amount = row.amount;
                const total = row.price ? (row.price * row.amount).toLocaleString() : '-';

                const rowArray = [username, socialNetwork, followers, postType, pricePerPost, amount, total];
                rows.push(rowArray);
            }
        }

        return {
            columns: columns,
            rows: rows
        };
    }

    async download(filename) {
        if (!filename.endsWith('.pdf')) {
            filename = `${filename}.pdf`
        }

        const content = this.generate();
        const tableTitle = filename.substr(0, filename.lastIndexOf('.'));
        const response = await axios.post('/table-downloader/pdf', {
            "title": tableTitle,
            "columns": content.columns,
            "rows": content.rows,
        }, {
            responseType: 'blob'
        })

        const newBlob = new Blob([response.data], {
            type: "application/pdf",
        });
        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(newBlob);
        } else {
            // Build a URL from the file
            const fileURL = URL.createObjectURL(newBlob);
            // download PDF
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style.display = 'none';
            a.href = fileURL;
            a.download = filename;
            a.click();

            document.body.removeChild(a);
        }
    }
}
